import { render, staticRenderFns } from "./PresentLevelsSubjectCheckboxWrapper.vue?vue&type=template&id=68ac1869&scoped=true"
import script from "./PresentLevelsSubjectCheckboxWrapper.vue?vue&type=script&lang=js"
export * from "./PresentLevelsSubjectCheckboxWrapper.vue?vue&type=script&lang=js"
import style0 from "./PresentLevelsSubjectCheckboxWrapper.vue?vue&type=style&index=0&id=68ac1869&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ac1869",
  null
  
)

export default component.exports